import React from 'react';
import { Form } from 'react-final-form';
import { Link } from 'react-router-dom';

import { SimpleButton } from '../../components';
import { SelectComponent } from '../../dsfr';
import { useSupportPage } from './support.hook';

export const SupportPage = React.memo(() => {
  const { memoizedErrorCodes, memoizedFraudSurveyOrigins, submitHandler } = useSupportPage();

  return (
    <Form
      initialValues={{
        errorCodeSelect: undefined,
        fraudSurveyOriginSelect: undefined,
      }}
      onSubmit={submitHandler}>
      {({ handleSubmit }) => (
        <form id="form" onSubmit={handleSubmit}>
          <p className="fr-text--lg fc-text--center">
            La tentative d’authentification via FranceConnect a échoué.
          </p>
          <p className="fr-text--lg fc-text--center">Que faire ?</p>
          <SelectComponent
            defaultOptionLabel="Aucun code sélectionné"
            label="Code d’erreur"
            name="errorCodeSelect"
            values={memoizedErrorCodes}
          />
          <ul className="fr-btns-group fr-btns-group--lg fr-mt-2w">
            <li>
              <SimpleButton className="fr-btn" label="Contacter le support FranceConnect" />
            </li>
            <li>
              <Link className="fr-btn" to="/formulaire/faq/securite">
                Formulaire sécurité FAQ
              </Link>
            </li>
            <li>
              <Link className="fr-btn" to="/formulaire/faq/contact">
                Formulaire contact FAQ
              </Link>
            </li>
          </ul>
          <SelectComponent
            defaultOptionLabel="Aucune provenance sélectionnée"
            label="Provenance questionnaire usurpation"
            name="fraudSurveyOriginSelect"
            values={memoizedFraudSurveyOrigins}
          />
          <ul className="fr-btns-group fr-btns-group--lg fr-mt-2w">
            <li>
              <SimpleButton
                className="fr-btn"
                label="Formulaire de contact usurpation d’identité"
              />
            </li>
          </ul>
        </form>
      )}
    </Form>
  );
});

SupportPage.displayName = 'SupportPage';
